<app-card [titleKey]="translationKey + 'cardTitle'">
  <div class="section-d-total">
    <labeled-content [label]="translationKey + 'totalSecuritiesValue'">
      <span class="data-labels">{{
        projectDetails().securitiesTotalOffer
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
  </div>
  <div class="section-d-grid">
    <labeled-content [label]="'general.typeOf'">
      <span class="data-labels">{{
        projectDetails().securitiesType
          | baseEnumItemById
            : "generic.securitiesType"
            : genericProjectStore.securitiesTypeEntities()
          | translate
      }}</span>
    </labeled-content>
    <labeled-content [label]="'general.bookingPrice'">
      <span class="data-labels">{{
        projectDetails().securitieBookingPrice
          | currencyFormat
          : projectDetails().currency
      }}</span>
    </labeled-content>
    <labeled-content [label]="'general.overBookingAcceptence'">
      <span class="data-labels">{{
        (projectDetails().oversubscriptionAcceptance ? "general.yes" : "general.no")
          | translate
      }}</span>
    </labeled-content>
    <labeled-content [label]="translationKey + 'oversubscriptionAllocation'">
      <span class="data-labels">{{
        projectDetails().oversubscriptionType
          | baseEnumItemById
            : "generic.overSubscriptionType"
            : genericProjectStore.overSubscriptionTypeEntities()
          | translate
      }}</span>
    </labeled-content>
  </div>
  <app-info-label [label]="translationKey + 'infoLabel'" />

  <div class="sub-header-wrap">
    <label class="sub-header">{{
      translationKey + "guarantorDetails" | translate
    }}</label>
  </div>
  @for (person of projectDetails().personsSectionD; track $index) {
    <app-name-position-email-display
      [namePositionEmailData]="getPersonData(person)"
    />
  }

  <div class="sub-header-wrap">
    <label class="sub-header">{{
      translationKey + "guaranteeTerms" | translate
    }}</label>
  </div>
  <div class="text-box guarantee-info">{{
    projectDetails().guaranteeOrSecurityInfo
  }}</div>

  <labeled-content [label]="translationKey + 'buybackCommitment'">
    <span class="data-labels">{{
      projectDetails().isRepurchaseCommitment
        ? ("general.yes" | translate) + ", " + (projectDetails().repurchaseCommitmentAndDeadline | date : "yyyy.MM.dd") + "-ig"
        : ("general.no" | translate)
    }}</span>
  </labeled-content>

  @if (projectDetails().financialAssetsSectionD?.length; as count) {
    <div class="sub-header-wrap">
      <label class="sub-header mb-3">{{
        translationKey + "nonEquityInstruments" | translate
      }}</label>
    </div>
    @for (asset of projectDetails().financialAssetsSectionD; track $index) {
      <app-not-owned-devices-display [financialAsset]="asset" />
    }
  }
</app-card>
